import { Fragment } from 'react';

import { Name } from './Styled';
import { Content } from '../../campaignIndex/components/CampaignNameCell.styles';

import { SnippetUsage, MESSAGE_MEDIUMS } from '../types';

type Props = {
  result: SnippetUsage;
};

export const UsageMediumCell = ({ result }: Props) => {
  const { id, messageMedium } = result;

  return (
    <Fragment key={id}>
      <Content data-test="usage-content">
        <Name data-test={`usage-template-medium-${id}`}>
          {messageMedium !== MESSAGE_MEDIUMS.SNIPPET ? messageMedium : ''}
        </Name>
      </Content>
    </Fragment>
  );
};
